<template>
  <vuetify-chip
    v-bind="$attrs"
    v-on="$listeners"
    @click="localValue = !localValue"
    :ripple="false"
    :class="`size--${size} figma-chip ${disabled ? 'disabled' : ''}`"
  >
    <slot name="icon"></slot>
    <slot></slot>
  </vuetify-chip>
</template>

<script>
import { VChip } from 'vuetify/lib/components'

export default {
  name: 'BaseTag',
  components: {
    'vuetify-chip': VChip,
  },
  data() {
    return {
      localValue: false,
    }
  },
  props: {
    value: {
      default: false,
    },
    size: {
      type: String,
      default: 'medium',
      validator: function (value) {
        return ['medium', 'small'].includes(value)
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value(val) {
      this.localValue = val
    },
    localValue(val) {
      this.$emit('input', val)
    },
  },
}
</script>

<style lang="scss" scoped>
.v-application .v-chip.figma-chip {
  border-radius: 8px;
  border: 1px solid var(--neutral-95-lightest-light);
  background: var(--neutral-100-white-light);
  color: var(--neutral-30-base-light);
  font-weight: 500;
  padding: 4px 16px;

  &.size--small {
    padding: 2px 8px;
    font-size: 12px;
    height: 24px;
  }

  &::before {
    opacity: 0 !important;
  }

  &:hover {
    background: var(--brand-99-lightest-light);
    border-color: var(--brand-80-light-light);
  }

  &:active {
    box-shadow: none !important;
  }

  &.v-chip--active {
    color: var(--brand-40-dark-light);
    background: var(--brand-95-lighter-light);
    border-color: var(--brand-60-base-light);

    &:hover {
      color: var(--brand-30-darker-light);
      background: var(--brand-80-light-light);
      border-color: var(--brand-80-light-light);
    }
  }

  &.disabled {
    background-color: var(--neutral-99-light) !important;
    border-color: var(--neutral-80-lighter-light) !important;
    color: var(--neutral-70-light) !important;
  }
}

.bg-dark {
  .v-application .v-chip.figma-chip {
    border-radius: 8px;
    border: 1px solid var(--neutral-95-lightest-dark);
    background: var(--neutral-100-white-dark);
    color: var(--neutral-30-base-dark);
    font-weight: 500;
    padding: 4px 16px;

    &:hover {
      background: var(--brand-99-lightest-dark);
      border-color: var(--brand-80-light-dark);
    }

    &:active {
      box-shadow: none !important;
    }

    &.v-chip--active {
      color: var(--brand-40-dark-dark);
      background: var(--brand-95-lighter-dark);
      border-color: var(--brand-60-base-dark);

      &:hover {
        color: var(--brand-30-darker-dark);
        background: var(--brand-80-light-dark);
        border-color: var(--brand-80-light-dark);
      }
    }
  }
}
</style>
